import { Reveal } from "./Reveal";
import { CheckCircle2 } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/6993066b-ff7c-42b2-b892-e8aa9d739ad3/images/ab24676a96542bb4dc9f7c5cb52972325d3ba815cd90650cf2a2ac68cb4ce397.png";

const PILLARS = [
  "AI-based digital risk stratification across 400+ medical data points",
  "100% DPDP-compliant data security and confidentiality",
  "Globally accessible Digital Medical History (DigiDoc Health Locker)",
  "Hybrid model: certified Health Coaches + Specialized Doctors",
];

export const DigiDoc = () => {
  return (
    <section
      id="digidoc"
      data-testid="digidoc-section"
      className="relative py-24 lg:py-32 bg-[#0A192F] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30">
        <img
          src={IMG}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/85 to-transparent" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16">
        <Reveal className="lg:col-span-6">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-white/40" />
            <span className="text-xs uppercase tracking-[0.3em] text-white/60">
              Flagship · DigiDoc Health
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight">
            The "GAP" company
            <br />
            for global prevention.
          </h2>
          <p className="mt-10 text-lg text-white/75 leading-relaxed max-w-xl">
            DigiDoc — built on the Healthy Plus ecosystem and its Healthy Plus
            India subsidiary — connects front-end preventive care to back-end
            care management. Digital tooling married with a human Health Coach,
            so doctors aren't overburdened and chronic-disease costs stop
            running away.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {[
              { v: "400+", l: "Medical data points" },
              { v: "15%", l: "MD workload reduction" },
              { v: "100%", l: "Paperless · DPDP-secure" },
            ].map((d) => (
              <div key={d.l} className="border-t border-white/20 pt-4">
                <div className="font-serif text-4xl ticker">{d.v}</div>
                <div className="mt-2 text-xs uppercase tracking-[0.3em] text-white/60">
                  {d.l}
                </div>
              </div>
            ))}
          </div>

          <a
            href="#contact"
            data-testid="digidoc-cta"
            className="mt-12 inline-flex items-center gap-3 px-7 py-4 bg-white text-[#0A192F] text-sm tracking-wide rounded-full hover:-translate-y-0.5 hover:shadow-2xl transition-all duration-300"
          >
            Partner with DigiDoc
            <span aria-hidden>→</span>
          </a>
        </Reveal>

        <Reveal delay={160} className="lg:col-span-6 lg:pl-10 lg:border-l lg:border-white/15">
          <div className="text-xs uppercase tracking-[0.3em] text-white/60 mb-8">
            What we build into the platform
          </div>
          <ul className="space-y-7">
            {PILLARS.map((p) => (
              <li key={p} className="flex items-start gap-4">
                <CheckCircle2 className="shrink-0 mt-1 text-white/80" size={20} />
                <span className="font-serif text-xl lg:text-2xl text-white/95 leading-snug">
                  {p}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
